import React, { ReactNode } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Slide, Typography, Button} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { Fonts } from "../types/Constants";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  // eslint-disable-next-line no-undef
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface AppConfirmDialogProps {
  dialogTitle: string | ReactNode;
  open: boolean;
  onDeny?: (isOpen: boolean) => void;
  title: string | ReactNode;
  content: string | ReactNode;
  onConfirm: () => void;
  confirmButtonTitle?: string;
  denyButtonTitle?: string;
  disableDenyButton?: boolean;
  buttonColour?: string;
}

const AppConfirmDialog: React.FC<AppConfirmDialogProps> = ({
  open,
  onDeny,
  onConfirm,
  title,
  content,
  dialogTitle,
  confirmButtonTitle = "Yes",
  denyButtonTitle = "No",
  disableDenyButton = false,
  buttonColour
}) => {
  return (
    <Dialog
      TransitionComponent={Transition}
      open={open}
      onClose={() => onDeny && onDeny(false)}
    >
      <DialogTitle>
        <Typography
          sx={{
            mb: 3,
            fontWeight: Fonts.SEMI_BOLD,
          }}
          id="alert-dialog-title"
        >
          {dialogTitle}
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{ color: "text.secondary", fontSize: 14 }}
        id="alert-dialog-description"
      >
        {title}<strong>{content}</strong>
      </DialogContent>
      <DialogActions
        sx={{
          pb: 5,
          px: 6,
        }}
      >
        {!disableDenyButton &&
          <Button
            variant="outlined"
            sx={{
              fontWeight: Fonts.MEDIUM,
            }}
            onClick={() => onDeny && onDeny(false)}
            color="secondary"
          >
            {denyButtonTitle}
          </Button>
        }
        <Button
          variant="contained"
          sx={{
            fontWeight: Fonts.MEDIUM,
            backgroundColor: buttonColour ? buttonColour : "primary",
            ":hover":{
              backgroundColor: buttonColour ? buttonColour : "primary"
            }
            
          }}
          onClick={onConfirm}
          autoFocus
        >
          {confirmButtonTitle}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppConfirmDialog;
